
<div class="form-floating" style="width:100%">
  <input id="GrundSelect" style="width:100%" class="form-control" [ngModel]="selection" (ngModelChange)="triggerChange($event)" [disabled]="!enabeld" [readonly]="!enabeld"
         [ngbTypeahead]="Items"
         [inputFormatter]="formatter"
         [resultFormatter]="formatter"
         [selectOnExact]="true" />

  <label for="GrundSelect">Seriennumer</label>
</div>


